// extracted by mini-css-extract-plugin
export var blogReturnBtn = "index-module--blogReturnBtn--igugB";
export var caseReturnBtn = "index-module--caseReturnBtn--Px+uP";
export var lowerReturnBtn = "index-module--lowerReturnBtn--8l7Df";
export var normalReturnBtn = "index-module--normalReturnBtn--FtWDS";